VGTierApp.PDPage.DisplayTiers = function () {
    this.DisplayTiersFn = function () {
      setTimeout(function () {
        jQuery('#tieres').remove();
        var selectedVariant_ = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
        if (selectedVariant_ != null) {
            var tiered_ = commonFields_PD.variantsMFArray_PD[selectedVariant_];
            if (tiered_ != "" && tiered_ != undefined) {
                var tieredSplit_ = tiered_.split(",");
                if (tieredSplit_[5] === 'true') {
                    if (globalFields.StartEndDateValid(tieredSplit_)) {
                        WriteTableHeading(tieredSplit_);
                        WriteTableRows(tieredSplit_, selectedVariant_);
                    }
                }
            }
        }
      }, 200);
    }

    this.OnVariantChange = function () {
       setTimeout(function () {
            $(".product-form__option select, .product-form__option input[type=radio]").change(function () {
                displayTiers.DisplayTiersFn();
            });
       }, 2000);
    }

    var TableHeadHtml = function (contentHtml, tableSelector, position) {
        jQuery(tableSelector).after(contentHtml)
    }

    var WriteTableHeading = function (tieredSplit_) {
        var tieredType = tieredSplit_[0].trim(), tableSelector = 'form[action="/cart/add"] .product-form__payment-container';
        if (commonFields_PD.tableSetting == "table1") {
            TableHeadHtml('<div id="tieres" class="table-first"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th></tr></thead><tbody id="table-1-data"></tbody></table></div>', tableSelector);
        }
        if (commonFields_PD.tableSetting == "table2") {
            var tbl2Hdr3Vlu = commonFields_PD.headerText3Value;
            if (tieredType == "fixed") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " %";
            }
            TableHeadHtml('<div id="tieres" class="table-second"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + tbl2Hdr3Vlu + '</th></tr></thead><tbody id="table-2-data"></tbody></table></div>', tableSelector);
        }

        if (commonFields_PD.tableSetting == "table3") {
            TableHeadHtml('<div id="tieres" class="table-third"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + commonFields_PD.headerText3Value + '</th></tr></thead><tbody id="table-3-data"></tbody></table></div>', tableSelector);
        }

        if (commonFields_PD.tableSetting == "table4") {
            TableHeadHtml('<div id="tieres" class="table-fourth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th></tr></thead><tbody id="table-4-data"></tbody></table></div>', tableSelector);
        }

        if (commonFields_PD.tableSetting == "table5") {
            var tbl5Hdr4Vlu = commonFields_PD.headerText4Value;
            if (tieredType == "fixed") {
                tbl5Hdr4Vlu = tbl5Hdr4Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl5Hdr4Vlu = tbl5Hdr4Vlu + " %";
            }
            TableHeadHtml('<div id="tieres" class="table-fifth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + commonFields_PD.headerText3Value + '</th><th class="custom-block4 heading">' + tbl5Hdr4Vlu + '</th></tr></thead><tbody id="table-5-data"></tbody></table></div>', tableSelector);
        }

        if (commonFields_PD.tableSetting == "table6") {
            var tbl6Hdr3Vlu = commonFields_PD.headerText3Value;
            if (tieredType == "fixed") {
                tbl6Hdr3Vlu = tbl6Hdr3Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl6Hdr3Vlu = tbl6Hdr3Vlu + " %";
            }
            TableHeadHtml('<div id="tieres" class="table-sixth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + tbl6Hdr3Vlu + '</th></tr></thead><tbody id="table-6-data"></tbody></table></div>', tableSelector);
        }
        if (commonFields_PD.tableSetting == "table7") {
            var tbl2Hdr3Vlu = commonFields_PD.headerText3Value;
            if (tieredType == "fixed") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " %";
            }
            TableHeadHtml('<div id="tieres" class="table-seventh"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + tbl2Hdr3Vlu + '</th></tr></thead><tbody id="table-7-data"></tbody></table></div>', tableSelector);
        }
    }

    var WriteTableRows = function (tieredSplit_, selectedVariant_) {
        var tieredType = tieredSplit_[0].trim(), originalPrice_ = commonFields_PD.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
        for (i = 6; i < tieredSplit_.length; i++) {
            var isBreakLoop = false, tieredRange_ = tieredSplit_[i].split("=")[0], tieredOff = Number(tieredSplit_[i].split("=")[1]);
            var tieredMin_ = parseInt(tieredRange_.split("-")[0]), tieredMax_ = tieredRange_.split("-")[1], discountedPrice = 0;

            if (tieredMax_ != "max") {
                tieredMax_ = parseInt(tieredRange_.split("-")[1]);
            }
            else {
                tieredMax_ = "+";
            }

            if (tieredType == "percentage") {
                discountedPrice = Number(originalPrice_.toFixed(2));
                var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
                discountedPrice = discountedPrice - originalPriceCut_;
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = "100%";
                    isBreakLoop = true;
                    tieredMax_ = "+";
                }
                else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = tieredOff + "%";
                }
            }
            else if (tieredType == "fixed_price") {
                discountedPrice = tieredOff.toFixed(2);
                tieredOff = tieredOff + globalFields.currencySymbol;
            }
            else {
                discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = originalPrice_ + globalFields.currencySymbol;
                    isBreakLoop = true;
                    tieredMax_ = "+";
                }
                else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = tieredOff + globalFields.currencySymbol;
                }
            }

            TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff);

            if (isBreakLoop) { break; }
        }
    }

    var TableRowHtml = function (contentHtml, tableSelector) {
        jQuery(tableSelector).append(contentHtml);
    }

    var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff) {
        var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
        var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + discountedPrice + globalFields.currencySymbol + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
        if (commonFields_PD.tableSetting == "table1") {
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + plusSign + '</td><td class="custom-block2 bdcontent">' + priceHtml + '</td></tr>', '#table-1-data');
        }

        if (commonFields_PD.tableSetting == "table2") {
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + buyText + tieredMin_ + plusSign + '</td><td class="custom-block2 bdcontent">' + priceHtml + '</td><td class="custom-block3 bdcontent">' + tieredOff + '</td></tr>', '#table-2-data');
        }

        if (commonFields_PD.tableSetting == "table3") {
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + '</td><td class="custom-block2 bdcontent">' + tieredMax_ + '</td><td class="custom-block3 bdcontent">' + priceHtml + '</td></tr>', '#table-3-data');
        }

        if (commonFields_PD.tableSetting == "table4") {
            var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable4 = tieredMin_ + "+";
            }
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + buyText + quantityTextTable4 + '</td><td class="custom-block2 bdcontent">' + priceHtml + '</td></tr>', '#table-4-data');
        }

        if (commonFields_PD.tableSetting == "table5") {
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + '</td><td class="custom-block2 bdcontent">' + tieredMax_ + '</td><td class="custom-block3 bdcontent">' + priceHtml + '</td><td class="custom-block4 bdcontent">' + tieredOff + '</td></tr>', '#table-5-data');
        }

        if (commonFields_PD.tableSetting == "table6") {
            var quantityTextTable6 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable6 = tieredMin_ + "+";
            }
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + buyText + quantityTextTable6 + '</td><td class="custom-block2 bdcontent">' + priceHtml + '</td><td class="custom-block3 bdcontent">' + tieredOff + '</td></tr>', '#table-6-data');
        }
        if (commonFields_PD.tableSetting == "table7") {
            var quantityTextTable6 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable6 = tieredMin_ + "+";
            }
            TableRowHtml('<tr><td class="custom-block1 bdcontent">' + buyText + quantityTextTable6 + '</td><td class="custom-block3 bdcontent">' + tieredOff + '</td></tr>', '#table-7-data');
        }
    }

}

var commonFields_PD = new VGTierApp.PDPage.Global(), displayTiers = new VGTierApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();